import type { Span } from '@opentelemetry/api';

import { normalizeUrlPath } from './normalize-url-path';

type XhrLike = { responseURL: string };

export function applyFetchSpanName(
  span: Span,
  request: Request | RequestInit,
  result: Response | { status?: number },
): void {
  const url =
    request instanceof Request
      ? request.url
      : 'url' in result
        ? (result as Response).url
        : undefined;
  if (!url) return;

  const method = (request.method || 'GET').toUpperCase();
  const path = normalizeUrlPath(url);
  if (path) {
    span.updateName(`HTTP ${method} ${path}`);
  }
}

export function applyXhrSpanName(span: Span, xhr: XhrLike): void {
  const url = xhr.responseURL;
  if (!url) return;

  const path = normalizeUrlPath(url);
  if (!path) return;

  const spanName = (span as unknown as { name?: string }).name;
  if (!spanName) return;
  const method = spanName.replace(/^HTTP\s+/, '') || 'GET';
  span.updateName(`HTTP ${method} ${path}`);
}
